import { useState } from "react";
import { useParams } from "react-router-dom";
import CheckoutDetails from "../components/CheckoutDetails";
import { Helmet } from "react-helmet";

export default function Checkout() {
  const params = useParams();

  const [products, setProducts] = useState(() => {
    const saved = localStorage.getItem("products");
    const initialValue = JSON.parse(saved);
    return initialValue || "";
  });

  return (
    <section className="my-20">
      <Helmet>
        <title>Dailysocialboost | Checkout</title>
      </Helmet>
      <h2 className="text-center text-5xl font-bold my-26">Checkout</h2>
      <div className=" flex flex-col  justify-center  ">
        <CheckoutDetails products={products} params={params}></CheckoutDetails>
      </div>
    </section>
  );
}
